// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  It applies to page with side bar.
  Example: systemParams -> systemParams.component.scss
*/
/*
  It applies to the title (header) of page content body.
*/
/*
  It describes common behavior on mouse hover.
*/
/*
  It describes light shadow for any page block.
*/
/*
  It applies to entity block like project, facility which has own title, edit button and body.
*/
/*
  It applies together with entity-card mixin, which has been described above
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
.tabs {
  display: flex;
  margin: 0;
  padding: 0;
}

a.tab-link {
  display: inline-block;
  font-weight: normal;
  font-size: 12px;
  font-family: GothamBookMedium, sans-serif;
  text-decoration: none;
  border: 0px;
  color: #c8c8c8;
  padding: 8px;
  padding-bottom: 4px;
  margin: 0;
  border-bottom: 4px solid transparent;
}
a.tab-link:hover {
  color: #0066b2;
}
a.tab-link:active, a.tab-link.active {
  color: #0b2d71;
  border-bottom-color: #0b2d71;
}

.tab {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tab-header {
  font-weight: normal;
  font-size: 16px;
  font-family: GothamBookMedium, sans-serif;
  margin: 16px 0;
}

.tab-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.button-wrapper {
  display: flex;
  gap: 10px;
  justify-content: center;
}

app-warning {
  margin-bottom: 10px;
}

.download-button {
  font-weight: normal;
  font-size: 16px;
  font-family: GothamNarrowBook, sans-serif;
  display: inline-block;
  border-width: 0;
  border-radius: 0;
  cursor: pointer;
  min-height: 30px;
  font-weight: bold;
  line-height: 22px;
  font-family: GothamBook, sans-serif;
  color: #fff;
  background-color: #0066b2;
  padding: 8px 16px;
}
.download-button.minw250 {
  min-width: 250px;
}
.download-button.minw200 {
  min-width: 200px;
}
.download-button.minw150 {
  min-width: 150px;
}
.download-button.minw100 {
  min-width: 100px;
}
.download-button.minw50 {
  min-width: 50px;
}
.download-button.minh40 {
  min-height: 40px;
}
.download-button:focus {
  outline: none;
}
.download-button mat-icon {
  vertical-align: middle;
}
.download-button:hover {
  background-color: #0b2d71;
}
.download-button:disabled {
  cursor: default;
  pointer-events: none;
  background-color: #c8c8c8;
  color: #fff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
